import { Component, Input } from '@angular/core';
@Component({
	selector: 'imv-dialogs',
	templateUrl: './dialogs.component.html',
	styleUrls: ['./dialogs.component.scss'],
})
export class DialogsComponent {
	@Input() i18n: any = null;
}
